import type { ComponentMap } from '@atlassian/forge-ui';
import { PortalTextArea } from './portalTextarea';

export const requestCreatePropertyPanelUIKitComponents: ComponentMap = {
	PortalTextArea,
};
